import $hlgbr$arAEmodulejs from "./ar-AE.mjs";
import $hlgbr$bgBGmodulejs from "./bg-BG.mjs";
import $hlgbr$csCZmodulejs from "./cs-CZ.mjs";
import $hlgbr$daDKmodulejs from "./da-DK.mjs";
import $hlgbr$deDEmodulejs from "./de-DE.mjs";
import $hlgbr$elGRmodulejs from "./el-GR.mjs";
import $hlgbr$enUSmodulejs from "./en-US.mjs";
import $hlgbr$esESmodulejs from "./es-ES.mjs";
import $hlgbr$etEEmodulejs from "./et-EE.mjs";
import $hlgbr$fiFImodulejs from "./fi-FI.mjs";
import $hlgbr$frFRmodulejs from "./fr-FR.mjs";
import $hlgbr$heILmodulejs from "./he-IL.mjs";
import $hlgbr$hrHRmodulejs from "./hr-HR.mjs";
import $hlgbr$huHUmodulejs from "./hu-HU.mjs";
import $hlgbr$itITmodulejs from "./it-IT.mjs";
import $hlgbr$jaJPmodulejs from "./ja-JP.mjs";
import $hlgbr$koKRmodulejs from "./ko-KR.mjs";
import $hlgbr$ltLTmodulejs from "./lt-LT.mjs";
import $hlgbr$lvLVmodulejs from "./lv-LV.mjs";
import $hlgbr$nbNOmodulejs from "./nb-NO.mjs";
import $hlgbr$nlNLmodulejs from "./nl-NL.mjs";
import $hlgbr$plPLmodulejs from "./pl-PL.mjs";
import $hlgbr$ptBRmodulejs from "./pt-BR.mjs";
import $hlgbr$ptPTmodulejs from "./pt-PT.mjs";
import $hlgbr$roROmodulejs from "./ro-RO.mjs";
import $hlgbr$ruRUmodulejs from "./ru-RU.mjs";
import $hlgbr$skSKmodulejs from "./sk-SK.mjs";
import $hlgbr$slSImodulejs from "./sl-SI.mjs";
import $hlgbr$srSPmodulejs from "./sr-SP.mjs";
import $hlgbr$svSEmodulejs from "./sv-SE.mjs";
import $hlgbr$trTRmodulejs from "./tr-TR.mjs";
import $hlgbr$ukUAmodulejs from "./uk-UA.mjs";
import $hlgbr$zhCNmodulejs from "./zh-CN.mjs";
import $hlgbr$zhTWmodulejs from "./zh-TW.mjs";

var $de5926a92e8ebc5b$exports = {};


































$de5926a92e8ebc5b$exports = {
    "ar-AE": $hlgbr$arAEmodulejs,
    "bg-BG": $hlgbr$bgBGmodulejs,
    "cs-CZ": $hlgbr$csCZmodulejs,
    "da-DK": $hlgbr$daDKmodulejs,
    "de-DE": $hlgbr$deDEmodulejs,
    "el-GR": $hlgbr$elGRmodulejs,
    "en-US": $hlgbr$enUSmodulejs,
    "es-ES": $hlgbr$esESmodulejs,
    "et-EE": $hlgbr$etEEmodulejs,
    "fi-FI": $hlgbr$fiFImodulejs,
    "fr-FR": $hlgbr$frFRmodulejs,
    "he-IL": $hlgbr$heILmodulejs,
    "hr-HR": $hlgbr$hrHRmodulejs,
    "hu-HU": $hlgbr$huHUmodulejs,
    "it-IT": $hlgbr$itITmodulejs,
    "ja-JP": $hlgbr$jaJPmodulejs,
    "ko-KR": $hlgbr$koKRmodulejs,
    "lt-LT": $hlgbr$ltLTmodulejs,
    "lv-LV": $hlgbr$lvLVmodulejs,
    "nb-NO": $hlgbr$nbNOmodulejs,
    "nl-NL": $hlgbr$nlNLmodulejs,
    "pl-PL": $hlgbr$plPLmodulejs,
    "pt-BR": $hlgbr$ptBRmodulejs,
    "pt-PT": $hlgbr$ptPTmodulejs,
    "ro-RO": $hlgbr$roROmodulejs,
    "ru-RU": $hlgbr$ruRUmodulejs,
    "sk-SK": $hlgbr$skSKmodulejs,
    "sl-SI": $hlgbr$slSImodulejs,
    "sr-SP": $hlgbr$srSPmodulejs,
    "sv-SE": $hlgbr$svSEmodulejs,
    "tr-TR": $hlgbr$trTRmodulejs,
    "uk-UA": $hlgbr$ukUAmodulejs,
    "zh-CN": $hlgbr$zhCNmodulejs,
    "zh-TW": $hlgbr$zhTWmodulejs
};


export {$de5926a92e8ebc5b$exports as default};
//# sourceMappingURL=intlStrings.module.js.map
